import { memo } from 'react';
import { imageUrl } from '@dfl/mui-react-common';
import { Avatar, AvatarProps } from '@mui/material';

type AvatarMediaProps = AvatarProps & {
  avatar?: any;
  name?: string;
  hd?: boolean;
};

const AvatarMedia = ({ avatar, name, hd, ...props }: AvatarMediaProps) => {
  const url = hd ? avatar?.url : avatar?.thumb;
  return <Avatar alt={name} {...props} src={imageUrl(url as string)} />;
};

export default memo(AvatarMedia);
